<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Offers
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                outlined
                v-model="form.offers_type"
                label="Offer type"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :items="offerTypeItems"
              ></v-autocomplete>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.description"
                outlined
                label="Text"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.url"
                outlined
                label="Url"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.percent"
                outlined
                label="Percentage"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.value"
                outlined
                label="Value"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    label="Start Date *"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="nowDate"
                  v-model="form.start_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col sm="4">
              <v-menu
                v-model="menu_three"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    label="End Date *"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.end_date"
                  :min="form.sign_off_date"
                  @input="menu_three = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save offer Details
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
  <script>
import axios from "axios";
export default {
  name: "OfferCreatePage",
  data() {
    return {
      form: {
        offers_type: "",
        description: "",
        url: "",
        percent: "",
        value: "",
        start_date: "",
        end_date: "",
      },
      offerTypeItems: [
        { text: "Web", value: "web" },
        { text: "Mobile", value: "mobile" },
      ],
      // errors: {
      //   offers_type: "",
      //   start_date: "",
      //   end_date: "",
      // },
      isLoading: false,
      nowDate: new Date().toISOString().substr(0, 10),
      menu: false,
      menu_three: false,
    };
  },

  methods: {
    async save() {
      try {
        this.isLoading = true;
        let notifications = await axios.post("/offers", this.form);
        this.notifications = notifications.data.data;

        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/offers");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
  